import React from 'react';
import { Text, TextVariant } from '@naf/text';
import { useLoginRedirect } from '@hooks/useLoginRedirect';
import { Close } from '@styled-icons/material/Close';
import { useNavigate } from 'react-router-dom';
import { Button } from '@naf-simba/elements-buttons';
import { mapSimbaVariant } from '@utils/simba/mapSimbaVariant';
import { useAuth0 } from '@auth0/auth0-react';
import * as S from './LoginModal.styles';
import { LoginModalImage, LOGIN_MODAL_IMAGE_MAP } from './LoginModal.utils';

interface LoginModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  body?: string;
  showBecomeMemberButton?: boolean;
  loginButtonText?: string;
  image?: LoginModalImage;
}

export const LoginModal = ({
  isOpen,
  onClose,
  title,
  body,
  showBecomeMemberButton,
  loginButtonText = 'Logg inn',
  image = LoginModalImage.RoadAssistance,
}: LoginModalProps) => {
  const { isAuthenticated } = useAuth0();
  const { redirectToLoginPage } = useLoginRedirect();
  const navigate = useNavigate();

  const navigateTo = (url: string) => {
    navigate(url);
  };

  const Image = LOGIN_MODAL_IMAGE_MAP[image];

  return (
    <S.ModalOverlay $isOpen={isOpen} onClick={onClose}>
      <S.ModalContent onClick={(e) => e.stopPropagation()}>
        <S.CloseButton onClick={onClose} aria-label="Lukk">
          <Close size={24} />
        </S.CloseButton>
        <Image />
        <Text tag="h2" variant={TextVariant.Header2}>
          {title}
        </Text>
        {body && (
          <Text tag="p" variant={TextVariant.ArticleText}>
            {body}
          </Text>
        )}
        <S.ModalButtons>
          {showBecomeMemberButton && (
            <Button
              variant={mapSimbaVariant(isAuthenticated ? 'signature' : 'outline').variant}
              onClick={() => navigateTo('/bli-medlem')}
            >
              Bli medlem
            </Button>
          )}
          {!isAuthenticated && (
            <Button
              variant={mapSimbaVariant('signature').variant}
              onClick={() => redirectToLoginPage(window.location.pathname)}
            >
              {loginButtonText}
            </Button>
          )}
        </S.ModalButtons>
      </S.ModalContent>
    </S.ModalOverlay>
  );
};
